export default function getChartOptions() {
	return {
		chart: {
			zoom: {
				enabled: false
			},
			toolbar: {
				show: false,
				tools: {
					download: false,
					selection: false,
					customIcons: [
						{
							icon:
								'<img src="/images/portrait/small/avatar-s-1.jpg" width="20"/>',
							index: 1,
							title: "tooltip of the icon",
							class: "custom-icon",
						}
					]
				}
			},
			selection: {
				enabled: false
			}
		},
		labels: [],
		colors: [
			"#7367F0",
			"#28C76F",
			"#EA5455",
			"#FF9F43",
			"#00CFE8",
			"#82868B"
		],

		legend: {
			show: true,
			showForSingleSeries: true,
			position: "bottom"
		},

		selection: {
			enabled: true
		},

		stroke: {
			curve: "smooth"
		},

		dataLabels: {
			enabled: true,
			formatter: function(value) {
				return value.toFixed(2) + "%";
			}
		},

		tooltips: {
			enabled: true,
			shared: true,
			y: {
				formatter: undefined
			},
			z: {
				formatter: undefined,
				title: "total:"
			}
		},

		xaxis: {
			// categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
			type: "datetime",
			categories: [],
			labels: {
				showDuplicates: false,
				rotateAlways: false,
				hideOverlappingLabels: true,
				formatter: undefined
			}
		}
	};
}
